import { render, staticRenderFns } from "./ObjetivosGenerales.vue?vue&type=template&id=4b0cd0a8"
import script from "./ObjetivosGenerales.vue?vue&type=script&lang=js"
export * from "./ObjetivosGenerales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports